export default __webpack_public_path__ + "static/media/2D.1d1aca22.webp";